// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4967":"monaco-9723f17f-0eae9a1f","6860":"monaco-9723f17f-2cdf052c"}[chunkId] + "." + {"4967":"b412a491","6860":"6409ab6f"}[chunkId] + ".chunk.css";
};